var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100%"}},[_c('iframe',{staticStyle:{"width":"100%","height":"100%","border":"0"},attrs:{"src":_vm.link}})])}
var staticRenderFns = []

export { render, staticRenderFns }